import React from "react";
import { MapPin, Building2, Phone, Clock } from "lucide-react";

const ProviderCard = ({ provider, onSelect }) => {
 


  return (
    <div
    onClick={() => onSelect(provider)}
    className="p-6 bg-gradient-to-br flex flex-col
    justify-between from-white to-gray-100 rounded-lg shadow-lg hover:shadow-xl transition-transform duration-300 transform hover:-translate-y-2 cursor-pointer"
  >
    <div className="flex gap-4">
      <img
        src={
          provider?.businessInformation?.displayImage ||
          "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=300&q=80"
        }
        alt={provider?.businessInformation?.legalName || "Unknown"}
        className="w-24 h-24 rounded-lg object-cover"
      />
      <div className="flex-1 flex flex-col justify-between max-w-full ">
        <p className="text-base font-semibold text-gray-600">
          {provider?.businessInformation?.legalName || "Unknown"}
        </p>
        <p className="text-brand-600 flex items-center gap-2 text-sm">
          <Building2 className="w-4 h-4" />
          {provider?.businessInformation?.type || "Healthcare Provider"}
        </p>
        <p className="text-gray-600 flex items-center gap-2 text-sm">
          <MapPin className="w-4 h-4" />
          {provider?.businessInformation?.city || "Unknown Location"}
        </p>
      </div>
    </div>
    <div className="mt-4 flex flex-col gap-2">
      <p className="text-gray-600 flex items-center gap-2 text-sm">
        <Phone className="w-4 h-4" />
        {provider?.businessInformation?.phoneNumber || "Contact Not Available"}
      </p>
      <p className="text-gray-600 flex items-center gap-2 text-sm">
        <Clock className="w-4 h-4" />
        24/7 Emergency Services
      </p>
    </div>
  </div>
  )
  
}

export default ProviderCard;
